import { Navigate, useParams } from "react-router-dom";
import useCapabilities, { useCanManageApplications, useCanViewCommitteesBool } from "@/hooks/useCapabilities";
import { useFlags } from "@/hooks/useFeatureFlags";
import usePageTitle from "@/hooks/usePageTitle";
import AppLayout from "@/layouts/AppLayout";
import { getMembershipServicesNavLinks } from "../../_membershipServicesNavLinks";
import { usePbdCardManualFulfillmentAccess } from "@/pages/people/membership-services/pbd-card-manual-fulfillment/access";
import CommitteeDetailPageContent from "./_components/CommitteeDetailPageContent";

export default function NationalCommitteeDetailPage() {
  const { committeeId } = useParams();
  const { loaded } = useCapabilities();
  const flags = useFlags();
  const canManageApplications = useCanManageApplications();
  const canViewCommittees = useCanViewCommitteesBool();
  const { canQueue } = usePbdCardManualFulfillmentAccess();
  const navLinks = getMembershipServicesNavLinks(flags, {
    canManageApplications,
    canViewCommittees,
    canQueuePbdCardManualFulfillment: canQueue
  });

  usePageTitle(`/people/membership-services/committees/${committeeId}`, "People | Committee");

  if (!canViewCommittees) {
    if (!loaded) {
      return null;
    }
    return <Navigate to="/people/membership-services" replace />;
  }

  if (!committeeId) {
    return null;
  }

  return (
    <AppLayout interior bottomBar navLinks={navLinks}>
      <CommitteeDetailPageContent committeeId={committeeId} committeeScope="national" showCatalogBreadcrumb />
    </AppLayout>
  );
}
